const initialState = {
    LOGIN_METHOD: null,
    OTP_PURPOSE: null,
    mobile: null,
    VFC_TOKEN: null,
    EPIN_SET: null,
    USER_DATA_FILLED: null,
//   name: null,
//   shopPincode: null,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_LOGIN_METHOD':
      return {
        ...state,
        LOGIN_METHOD: action.payload,
      };
    case 'SET_OTP_PURPOSE':
      return {
        ...state,
        OTP_PURPOSE: action.payload,
      };
    case 'SET_MOBILE':
      return {
        ...state,
        mobile: action.payload,
      };
    case 'SET_VFC_TOKEN':
      return {
        ...state,
        VFC_TOKEN: action.payload,
      };
    case 'SET_EPIN_SET':
      return {
        ...state,
        EPIN_SET: action.payload,
      };
    case 'SET_USER_DATA_FILLED':
      return {
        ...state,
        USER_DATA_FILLED: action.payload,
      };
    case 'RESET_MOBILE':
      return {
        ...state,
        mobile: null,
      };
    case 'RESET_SET_EPIN':
      return {
        ...state,
        EPIN_SET: null,
      };
    case 'RESET_USER_DATA_FILLED':
      return {
        ...state,
        USER_DATA_FILLED: null,
      };
    case 'RESET_VFC_TOKEN':
        return {
        ...state,
        VFC_TOKEN: null,
    };
    case 'RESET_AUTH':
      return initialState;
    default:
      return state;
  }
};

export default authReducer;